module.exports = __webpack_public_path__ + "img/image3.be9ea82f.jpg";